/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Vehicle_Hidden_Defect_DescriptionInputs */

const en_case_section_vehicle_hidden_defect_description = /** @type {(inputs: Case_Section_Vehicle_Hidden_Defect_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The vehicle affected by the hidden defect.`)
};

const pt_br2_case_section_vehicle_hidden_defect_description = /** @type {(inputs: Case_Section_Vehicle_Hidden_Defect_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O veículo que apresenta o defeito oculto.`)
};

/**
* | output |
* | --- |
* | "The vehicle affected by the hidden defect." |
*
* @param {Case_Section_Vehicle_Hidden_Defect_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_vehicle_hidden_defect_description = /** @type {((inputs?: Case_Section_Vehicle_Hidden_Defect_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Vehicle_Hidden_Defect_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_vehicle_hidden_defect_description(inputs)
	return pt_br2_case_section_vehicle_hidden_defect_description(inputs)
});